var exports = {
  "k": "x4c3adb35--bde3f3--container",
};

module.exports = exports;
